import { api } from '@/redux/api';
import { RootState } from '@/redux/store';
import { OrganisationIdAndNameOnly } from '@/types/organisation';
import { Unit } from '@/types/unit';
import { findById } from '@/utils/find-by-id';

export const selectUnitById =
  (organisation: OrganisationIdAndNameOnly, unitId: number) =>
  (state: RootState): Unit | undefined => {
    const { data: units } = api.endpoints.getUnits.select({ organisation })(
      state,
    );
    return findById(units ?? [], unitId);
  };
